export default __webpack_public_path__ + "ca6a756ef5777ecb30692fd2dd3bb71f.png";